// mixins/FeaturedIconsMixin.js
import { mapGetters } from 'vuex'
import { startCase, take } from 'lodash'
import { DEFAULT_STYLING } from 'app/views/icons/defaults'
import { RouteValidationMixin } from 'app/mixins'

const RESET_MODAL_STYLING = { ...DEFAULT_STYLING, family: null, style: null }

export const FeaturedIconsMixin = {
  computed: {
    ...mapGetters('iconPopularityList', { popularIconsByType: 'getByType' })
  },

  methods: {
    getFeaturedIcons(iconPackName, iconSetSize = 16) {
      const type = iconPackName === 'brands' ? 'brand' : 'default'
      const icons = this.popularIconsByType(type)
      return take(icons, iconSetSize)
    }
  }
}

export const IconLabelMixin = {
  methods: {
    getFamilyStyleLabel(family, style) {
      return `${startCase(family)} ${startCase(style)}`
    }
  }
}

export const ModalIconDetailMixin = {
  mixins: [RouteValidationMixin],

  data() {
    return {
      selectedIcon: null,
      selectedIconId: null,
      selectedFamily: null,
      selectedStyle: null,
      isShowingIconModal: false
    }
  },

  methods: {
    applyIconSelectionState(icon) {
      // Normalize the icon to handle brands icons consistently
      const normalizedIcon = this.normalizeBrandsIcon(icon)

      // Update selection state with normalized values
      this.selectedFamily = normalizedIcon.family
      this.selectedStyle = normalizedIcon.style

      // Update styling to match the normalized icon
      this.ensureStyling()
      this.styling = { ...this.styling, family: normalizedIcon.family, style: normalizedIcon.style }
    },

    ensureStyling() {
      if (!this.styling) {
        this.styling = { ...RESET_MODAL_STYLING }
      }
    },

    openIconModal(icon, originalRoute = null) {
      if (this.selectedIconId === icon.name && this.selectedStyle === icon.style && this.selectedFamily === icon.family) {
        this.closeIconModal(originalRoute)
      } else {
        this.selectedIcon = icon
        this.selectedIconId = icon.name
        this.isShowingIconModal = true
        this.applyIconSelectionState(icon)

        if (this.$refs && this.$refs.iconModal && typeof this.$refs.iconModal.closeEditor === 'function') {
          this.$refs.iconModal.closeEditor()
        }

        const url = this.$router.resolve({
          name: 'latest.icons.detail',
          params: { icon: this.selectedIconId },
          query: { f: this.selectedFamily, s: this.selectedStyle }
        }).href
        history.pushState({}, null, url)
      }
    },

    closeIconModal(originalRoute) {
      if (this.selectedIconId) {
        this.selectedIcon = null
        this.selectedIconId = null
        this.selectedFamily = null
        this.selectedStyle = null
        this.isShowingIconModal = false
        this.styling = { ...RESET_MODAL_STYLING }

        if (originalRoute && this.validateRoute(originalRoute)) {
          const url = this.$router.resolve(originalRoute).href
          history.replaceState({}, null, url)
        }
      }
    }
  }
}
